import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = [
    { label: t('footer.privacy'), to: '/about' },
    { label: t('footer.terms'), to: '/about' },
    { label: t('footer.contact'), to: '/about' },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-fill text-foreground-950 text-sm"></i>
            </div>
            <span className="text-foreground-800 font-bold text-base font-heading">
              {t('site.name')}
            </span>
          </div>

          <div className="flex items-center gap-6">
            {footerLinks.map((link) => (
              <Link
                key={link.label}
                to={link.to}
                className="text-foreground-500 hover:text-foreground-800 text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </Link>
            ))}
          </div>

          <p className="text-foreground-400 text-xs whitespace-nowrap">
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}